import React, { useEffect, useState } from "react";

import { Grid, Button, CircularProgress, Stack, TextField } from "@mui/material";

import { GOOGLE_CLIENT_ID, MICROSOFT_CLIENT_ID, LOGIN_REDIRECT_URI } from '../../../common/constants';
import { rgba } from '../../../common/functions';

const Credentials = ({ setEmail, setPassword, handleSubmit, setFullName, create = false, submitting = false }) => {
  

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item>
        <Stack mb="25px" justifyContent="center" alignItems="center" spacing={2}>
          
          {create && (
            <TextField
              label="Full Name"
              variant="outlined"
              onChange={(event) => setFullName(event.target.value)}
              fullWidth
            />
          )}
          
          <TextField
            label="Email"
            variant="outlined"
            onChange={(event) => setEmail(event.target.value)}
            fullWidth
          />

          <TextField
            label="Password"
            variant="outlined"
            type="password"
            onChange={(event) => setPassword(event.target.value)}
            fullWidth
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            disabled={submitting}
            onClick={() => {
              handleSubmit();
            }}
          >
            {submitting && <CircularProgress color="inherit" size={20} sx={{ mr: 1 }} />}
            Sign {create ? 'Up' : 'In'}
          </Button>

        </Stack>
      </Grid>
    </Grid>
  );
};

export default Credentials;
